// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__82Vde","content":"styles_content__3HSij","title":"styles_title__112wA","subtitle":"styles_subtitle__1ZE72"};